export default __webpack_public_path__ + "static/greendjinn-ce8d4a6d32992fc2dcf71bce78f1d060.svg";